{
  "HELP_CENTER": {
    "TITLE": "Trung tâm trợ giúp",
    "NEW_PAGE": {
      "DESCRIPTION": "Tạo các cổng trung tâm trợ giúp tự phục vụ cho khách hàng của bạn. Giúp họ tìm câu trả lời nhanh chóng, không cần chờ đợi. Tinh gọn các yêu cầu, nâng cao hiệu suất của agent và cải thiện chất lượng hỗ trợ khách hàng.",
      "CREATE_PORTAL_BUTTON": "Tạo cổng"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Chưa có tiêu đề"
    },
    "HEADER": {
      "FILTER": "Lọc theo",
      "SORT": "Sắp xếp theo",
      "LOCALE": "Ngôn ngữ",
      "SETTINGS_BUTTON": "Cài đặt",
      "NEW_BUTTON": "Bài viết mới",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Đã phát hành",
        "DRAFT": "Draft",
        "ARCHIVED": "Đã lưu trữ"
      },
      "TITLES": {
        "ALL_ARTICLES": "Tất cả bài viết",
        "MINE": "Các bài của tôi",
        "DRAFT": "Bài viết Draft",
        "ARCHIVED": "Các bài viết đã lưu trữ"
      },
      "LOCALE_SELECT": {
        "TITLE": "Chọn ngôn ngữ",
        "PLACEHOLDER": "Chọn ngôn ngữ",
        "NO_RESULT": "Không tìm thấy ngôn ngữ",
        "SEARCH_PLACEHOLDER": "Tìm ngôn ngữ"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Tất cả bài viết",
      "PUBLISH_BUTTON": "Phát hành",
      "MOVE_TO_ARCHIVE_BUTTON": "Di chuyển đến lưu trữ",
      "PREVIEW": "Xem trước",
      "ADD_TRANSLATION": "Thêm bản dịch",
      "OPEN_SIDEBAR": "Mở thanh bên",
      "CLOSE_SIDEBAR": "Đóng thanh bên",
      "SAVING": "Đang lưu...",
      "SAVED": "Đã lưu"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Tải lên hình ảnh",
        "UPLOADING": "Đang tải lên...",
        "SUCCESS": "Ảnh tải lên thành công",
        "ERROR": "Lỗi khi tải ảnh lên",
        "UN_AUTHORIZED_ERROR": "Bạn không có quyền tải ảnh lên",
        "ERROR_FILE_SIZE": "Kích thước ảnh phải nhỏ hơn {size}MB",
        "ERROR_FILE_FORMAT": "Ảnh phải có định dạng jpg, jpeg hoặc png",
        "ERROR_FILE_DIMENSIONS": "Kích thước ảnh phải nhỏ hơn 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Chèn neo",
        "TITLE": "Chèn neo",
        "SUBMIT": "Chèn",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Cài đặt bài viết",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Danh mục",
          "TITLE": "Chọn loại",
          "PLACEHOLDER": "Chọn loại",
          "NO_RESULT": "Không tìm thấy loại",
          "SEARCH_PLACEHOLDER": "Tìm danh mục"
        },
        "AUTHOR": {
          "LABEL": "Tác giả",
          "TITLE": "Chọn tác giả",
          "PLACEHOLDER": "Chọn tác giả",
          "NO_RESULT": "Không tìm thấy tác giả",
          "SEARCH_PLACEHOLDER": "Tìm tác giả"
        },
        "META_TITLE": {
          "LABEL": "Tiêu đề meta",
          "PLACEHOLDER": "Thêm Tiêu đề meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Mô tả meta",
          "PLACEHOLDER": "Thêm mô tả meta của bạn để có kết quả SEO tốt hơn..."
        },
        "META_TAGS": {
          "LABEL": "Các thẻ meta",
          "PLACEHOLDER": "Thêm các thẻ meta bằng dấu phẩy..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Lưu trữ bài viết",
        "DELETE": "Xoá bài"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Chưa được phân loại",
      "SEARCH_RESULTS": "Kết quả tìm kiếm cho {query}",
      "EMPTY_TEXT": "Tìm bài viết để chèn vào phản hồi.",
      "SEARCH_LOADER": "Đang tìm kiếm...",
      "INSERT_ARTICLE": "Thêm vào",
      "NO_RESULT": "Không có bài viết nào",
      "COPY_LINK": "Sao chép liên kết bài viết vào bộ nhớ tạm",
      "OPEN_LINK": "Mở bài viết trong tab mới",
      "PREVIEW_LINK": "Xem trước bài viết"
    },
    "PORTAL": {
      "HEADER": "Cổng",
      "DEFAULT": "Mặc định",
      "NEW_BUTTON": "Cổng mới",
      "ACTIVE_BADGE": "có hiệu lực",
      "CHOOSE_LOCALE_LABEL": "Chọn một ngôn ngữ",
      "LOADING_MESSAGE": "Đang tải cổng...",
      "ARTICLES_LABEL": "bài viết",
      "NO_PORTALS_MESSAGE": "Không có cổng nào",
      "ADD_NEW_LOCALE": "Thêm ngôn ngữ",
      "POPOVER": {
        "TITLE": "Cổng",
        "PORTAL_SETTINGS": "Cài đặt cổng",
        "SUBTITLE": "Bạn có nhiều cổng và có thể có các ngôn ngữ khác nhau cho mỗi cổng.",
        "CANCEL_BUTTON_LABEL": "Huỷ",
        "CHOOSE_LOCALE_BUTTON": "Chọn ngôn ngữ"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "bài viết",
            "ADD": "Thêm ngôn ngữ",
            "VISIT": "Xem trang",
            "SETTINGS": "Cài đặt",
            "DELETE": "Xoá"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Cấu hình Cổng thông tin",
            "ITEMS": {
              "NAME": "Tên",
              "DOMAIN": "Tên miền tuỳ chỉnh",
              "SLUG": "Slug",
              "TITLE": "Tiêu đề cổng",
              "THEME": "Màu chủ đề",
              "SUB_TEXT": "Tiêu đề phụ của cổng thông tin"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Các ngôn ngữ sẵn có",
            "TABLE": {
              "NAME": "Tên ngôn ngữ",
              "CODE": "Mã ngôn ngữ",
              "ARTICLE_COUNT": "Số lượng bài",
              "CATEGORIES": "Số danh mục",
              "SWAP": "Chuyển",
              "DELETE": "Xoá",
              "DEFAULT_LOCALE": "Mặc định"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Xóa cổng thông tin",
          "MESSAGE": "Bạn có chắc chắn muốn xóa cổng thông tin này",
          "YES": "Có, xóa cổng thông tin",
          "NO": "Không, giữ cổng thông tin",
          "API": {
            "DELETE_SUCCESS": "Đã xóa cổng thông tin thành công",
            "DELETE_ERROR": "Lỗi khi xóa cổng thông tin"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Sửa cổng thông tin",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Thông tin cơ bản"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Tuỳ chỉnh cổng thông tin"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Danh mục"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Ngôn ngữ"
          }
        },
        "CATEGORIES": {
          "TITLE": "Các danh mục trong",
          "NEW_CATEGORY": "Tạo danh mục",
          "TABLE": {
            "NAME": "Tên",
            "DESCRIPTION": "Mô tả",
            "LOCALE": "Ngôn ngữ",
            "ARTICLE_COUNT": "Số lượng bài",
            "ACTION_BUTTON": {
              "EDIT": "Sửa danh mục",
              "DELETE": "Xoá danh mục"
            },
            "EMPTY_TEXT": "Không tìm thấy danh mục nào"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Cập nhật thông tin cơ bản"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Thông tin trung tâm trợ giúp",
            "BODY": "Thông tin cơ bản về cổng"
          },
          "CUSTOMIZATION": {
            "TITLE": "Tùy chỉnh trung tâm trợ giúp",
            "BODY": "Tuỳ chỉnh cổng"
          },
          "FINISH": {
            "TITLE": "Tới rồi! 🎉",
            "BODY": "Bạn đã sẵn sàng!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Trở về",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Tạo cổng",
            "TITLE": "Thông tin trung tâm trợ giúp",
            "CREATE_BASIC_SETTING_BUTTON": "Tạo cài đặt cơ bản cho cổng thông tin"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Tuỳ biến cổng",
            "TITLE": "Tùy chỉnh trung tâm trợ giúp",
            "UPDATE_PORTAL_BUTTON": "Cập nhật thông tin cấu hình cổng"
          },
          "FINISH_PAGE": {
            "TITLE": "Tới rồi!🎉 Bạn đã sẵn sàng!",
            "MESSAGE": "Bây giờ bạn có thể thấy cổng được tạo này trên trang tất cả các cổng của bạn.",
            "FINISH": "Đi đến tất cả các trang cổng thông tin"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Tải lên logo",
          "HELP_TEXT": "Logo này sẽ được hiển thị trên tiêu đề cổng thông tin.",
          "IMAGE_UPLOAD_SUCCESS": "Đã tải logo lên thành công",
          "IMAGE_UPLOAD_ERROR": "Đã xóa logo thành công",
          "IMAGE_DELETE_ERROR": "Lỗi khi xóa logo"
        },
        "NAME": {
          "LABEL": "Tên",
          "PLACEHOLDER": "Tên cổng",
          "HELP_TEXT": "Tên sẽ được sử dụng trong nội bộ cổng thông tin công khai.",
          "ERROR": "Tên bắt buộc có"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug cổng cho các url",
          "ERROR": "Phải có Slug"
        },
        "DOMAIN": {
          "LABEL": "Tên miền tuỳ biến",
          "PLACEHOLDER": "Tên miền tuỳ biến cổng",
          "HELP_TEXT": "Chỉ thêm nếu bạn muốn sử dụng tên miền tuỳ chỉnh cho cổng thông tin của bạn. Ví dụ: {exampleURL}",
          "ERROR": "Nhập một URL tên miền hợp lệ"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Liên kết trang chủ",
          "PLACEHOLDER": "Liên kết trang chủ cổng thông tin",
          "HELP_TEXT": "Liên kết dùng để quay lại trang chủ từ cổng thông tin. Ví dụ: {exampleURL}",
          "ERROR": "Nhập một URL trang chủ hợp lệ"
        },
        "THEME_COLOR": {
          "LABEL": "Màu chủ đề cổng thông tin",
          "HELP_TEXT": "Màu này sẽ hiển thị dưới dạng màu chủ đề cho cổng thông tin."
        },
        "PAGE_TITLE": {
          "LABEL": "Tiêu đề trang",
          "PLACEHOLDER": "Tiêu đề trang cổng thông tin",
          "HELP_TEXT": "Tiêu đề trang sẽ được sử dụng trong cổng công khai.",
          "ERROR": "Phải có Tiêu đề trang"
        },
        "HEADER_TEXT": {
          "LABEL": "Văn bản tiêu đề",
          "PLACEHOLDER": "Văn bản tiêu đề cổng thông tin",
          "HELP_TEXT": "Văn bản tiêu đề Cổng thông tin sẽ được sử dụng trong cổng thông tin công khai.",
          "ERROR": "Phải có Văn bản tiêu đề cổng"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Cổng thông tin được tạo thành công.",
          "ERROR_MESSAGE_FOR_BASIC": "Không thể tạo cổng. Thử lại.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Cổng thông tin được cập nhật thành công.",
          "ERROR_MESSAGE_FOR_UPDATE": "Không thể cập nhật cổng. Thử lại."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Thêm ngôn ngữ",
        "SUB_TITLE": "Việc này sẽ thêm một ngôn ngữ mới vào danh sách của bạn.",
        "PORTAL": "Cổng",
        "LOCALE": {
          "LABEL": "Ngôn ngữ",
          "PLACEHOLDER": "Chọn một ngôn ngữ",
          "ERROR": "Ngôn ngữ là bắt buộc"
        },
        "BUTTONS": {
          "CREATE": "Tạo ngôn ngữ",
          "CANCEL": "Huỷ"
        },
        "API": {
          "SUCCESS_MESSAGE": "Ngôn ngữ được thêm thành công",
          "ERROR_MESSAGE": "Không thể thêm ngôn ngữ. Vui lòng thử lại."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Ngôn ngữ mặc định được cập nhật thành công",
          "ERROR_MESSAGE": "Không thể thay đổi ngôn ngữ mặc định. Vui lòng thử lại."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Ngôn ngữ đã được gỡ bỏ thành công khỏi cổng thông tin",
          "ERROR_MESSAGE": "Không thể gỡ ngôn ngữ khỏi cổng thông tin. Vui lòng thử lại."
        }
      }
    },
    "TABLE": {
      "404": "Không có bài viết nào phù hợp với tìm kiếm của bạn 🔍",
      "LOADING_MESSAGE": "Đang tải bài viết...",
      "NO_ARTICLES": "Không có bài viết nào có sẵn",
      "HEADERS": {
        "TITLE": "Tiêu đề",
        "CATEGORY": "Loại",
        "READ_COUNT": "Lượt xem",
        "STATUS": "Trạng thái",
        "LAST_EDITED": "Sửa lần cuối"
      },
      "COLUMNS": {
        "BY": "bởi",
        "AUTHOR_NOT_AVAILABLE": "Không có tác giả"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Đang tải bài viết...",
      "TITLE_PLACEHOLDER": "Tiêu đề bài viết ở đây",
      "CONTENT_PLACEHOLDER": "Viết bài của bạn ở đây",
      "API": {
        "ERROR": "Lỗi khi lưu bài viết"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Lỗi khi xuất bản bài viết",
        "SUCCESS": "Bài viết xuất bản thành công"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Lỗi khi lưu trữ bài viết",
        "SUCCESS": "Lưu trữ bài viết thành công"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Lỗi khi lưu bài viết dưới dạng Draft",
        "SUCCESS": "Đã lưu bài viết dưới dạng Draft thành công"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Xác nhận xoá",
          "MESSAGE": "Bạn có chắc chắn xóa bài viết?",
          "YES": "Có, Xoá",
          "NO": "Không, Giữ"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Đã xóa bài viết thành công",
        "ERROR_MESSAGE": "Lỗi khi xóa bài viết"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Vui lòng thêm tiêu đề và nội dung bài viết sau đó mới có thể cập nhật cài đặt"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Tìm kiếm bài viết"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Tạo một danh mục",
        "SUB_TITLE": "Danh mục sẽ được sử dụng trong cổng thông tin công khai để phân loại các bài.",
        "PORTAL": "Cổng",
        "LOCALE": "Ngôn ngữ",
        "NAME": {
          "LABEL": "Tên",
          "PLACEHOLDER": "Tên danh mục",
          "HELP_TEXT": "Tên và biểu tượng danh mục sẽ được sử dụng trong cổng thông tin công khai để phân loại bài viết.",
          "ERROR": "Tên bắt buộc có"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Danh mục slug cho url",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Phải có Slug"
        },
        "DESCRIPTION": {
          "LABEL": "Mô tả",
          "PLACEHOLDER": "Đưa ra một mô tả ngắn về danh mục.",
          "ERROR": "Mô tả bắt buộc có"
        },
        "BUTTONS": {
          "CREATE": "Tạo danh mục",
          "CANCEL": "Huỷ"
        },
        "API": {
          "SUCCESS_MESSAGE": "Danh mục đã được tạo thành công",
          "ERROR_MESSAGE": "Không thể tạo danh mục"
        }
      },
      "EDIT": {
        "TITLE": "Chỉnh sửa danh mục",
        "SUB_TITLE": "Chỉnh sửa danh mục sẽ cập nhật danh mục trong cổng thông tin công khai.",
        "PORTAL": "Cổng",
        "LOCALE": "Ngôn ngữ",
        "NAME": {
          "LABEL": "Tên",
          "PLACEHOLDER": "Tên danh mục",
          "HELP_TEXT": "Tên và biểu tượng danh mục sẽ được sử dụng trong cổng thông tin công khai để phân loại bài viết.",
          "ERROR": "Tên bắt buộc có"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Danh mục slug cho url",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Phải có Slug"
        },
        "DESCRIPTION": {
          "LABEL": "Mô tả",
          "PLACEHOLDER": "Đưa ra một mô tả ngắn về danh mục.",
          "ERROR": "Mô tả bắt buộc có"
        },
        "BUTTONS": {
          "CREATE": "Cập nhật danh mục",
          "CANCEL": "Huỷ"
        },
        "API": {
          "SUCCESS_MESSAGE": "Danh mục cập nhật thành công",
          "ERROR_MESSAGE": "Không thể cập nhật danh mục"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Xoá danh mục thành công",
          "ERROR_MESSAGE": "Không thể xoá danh mục"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Tìm kiếm bài viết",
      "PLACEHOLDER": "Tìm kiếm bài viết",
      "NO_RESULT": "Không có bài viết nào",
      "SEARCHING": "Đang tìm kiếm...",
      "SEARCH_BUTTON": "Tìm kiếm",
      "INSERT_ARTICLE": "Chèn liên kết",
      "IFRAME_ERROR": "URL trống hoặc không hợp lệ. Không thể hiển thị nội dung.",
      "OPEN_ARTICLE_SEARCH": "Chèn bài viết từ Trung tâm trợ giúp",
      "SUCCESS_ARTICLE_INSERTED": "Đã chèn bài viết thành công",
      "PREVIEW_LINK": "Xem trước bài viết",
      "CANCEL": "Đóng",
      "BACK": "Trở về",
      "BACK_RESULTS": "Quay lại kết quả"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Trung tâm trợ giúp",
      "DESCRIPTION": "Tạo các cổng thông tin tự phục vụ thân thiện với người dùng. Giúp người dùng của bạn truy cập bài viết và nhận hỗ trợ 24/7. Nâng cấp gói đăng ký của bạn để bật tính năng này.",
      "SELF_HOSTED_DESCRIPTION": "Tạo các cổng thông tin tự phục vụ thân thiện với người dùng. Giúp người dùng của bạn truy cập bài viết và nhận hỗ trợ 24/7. Vui lòng liên hệ với quản trị viên của bạn để bật tính năng này.",
      "BUTTON": {
        "LEARN_MORE": "Tìm hiểu thêm",
        "UPGRADE": "Nâng cấp"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Nhiều cổng thông tin",
          "DESCRIPTION": "Tạo nhiều cổng trung tâm trợ giúp cho các sản phẩm khác nhau bằng cùng một tài khoản."
        },
        "LOCALES": {
          "TITLE": "Hỗ trợ đầy đủ đa ngôn ngữ",
          "DESCRIPTION": "Bản địa hoá cổng thông tin theo ngôn ngữ của bạn. Chúng tôi hỗ trợ mọi ngôn ngữ và cho phép dịch mọi bài viết."
        },
        "SEO": {
          "TITLE": "Thiết kế thân thiện với SEO",
          "DESCRIPTION": "Tuỳ chỉnh thẻ meta để cải thiện khả năng hiển thị trên công cụ tìm kiếm với các trang thân thiện SEO của chúng tôi."
        },
        "API": {
          "TITLE": "Hỗ trợ đầy đủ API",
          "DESCRIPTION": "Sử dụng cổng thông tin như một CMS headless với các framework front-end của bên thứ ba thông qua API của chúng tôi."
        }
      }
    },
    "LOADING": "Đang tải...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} lượt xem | {count} lượt xem",
          "DROPDOWN_MENU": {
            "PUBLISH": "Phát hành",
            "DRAFT": "Draft",
            "ARCHIVE": "Lưu trữ",
            "DELETE": "Xoá"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Đã phát hành",
            "ARCHIVED": "Đã lưu trữ"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Chưa phân loại"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Tất cả bài viết",
          "MINE": "Của tôi",
          "DRAFT": "Draft",
          "PUBLISHED": "Đã phát hành",
          "ARCHIVED": "Đã lưu trữ"
        },
        "CATEGORY": {
          "ALL": "Tất cả danh mục"
        },
        "LOCALE": {
          "ALL": "Tất cả ngôn ngữ"
        },
        "NEW_ARTICLE": "Bài viết mới"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Viết bài viết",
          "SUBTITLE": "Viết một bài viết phong phú, hãy bắt đầu nào!",
          "BUTTON_LABEL": "Bài viết mới"
        },
        "MINE": {
          "TITLE": "Bạn chưa viết bài viết nào ở đây",
          "SUBTITLE": "Tất cả bài viết do bạn viết sẽ hiển thị ở đây để truy cập nhanh."
        },
        "DRAFT": {
          "TITLE": "Không có bài viết Draft nào",
          "SUBTITLE": "Bài viết Draft sẽ hiển thị ở đây"
        },
        "PUBLISHED": {
          "TITLE": "Không có bài viết nào đã xuất bản",
          "SUBTITLE": "Bài viết đã xuất bản sẽ hiển thị ở đây"
        },
        "ARCHIVED": {
          "TITLE": "Không có bài viết nào trong lưu trữ",
          "SUBTITLE": "Bài viết đã lưu trữ sẽ không hiển thị trên cổng thông tin, bạn có thể dùng để đánh dấu các trang đã lỗi thời hoặc không còn dùng nữa"
        },
        "CATEGORY": {
          "TITLE": "Không có bài viết nào trong danh mục này",
          "SUBTITLE": "Bài viết trong danh mục này sẽ hiển thị ở đây"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Tạo danh mục",
        "EDIT_CATEGORY": "Sửa danh mục",
        "CATEGORIES_COUNT": "{n} danh mục | {n} danh mục",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Danh mục ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} bài viết) | {categoryName} ({categoryCount} bài viết)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Không tìm thấy danh mục nào",
        "SUBTITLE": "Danh mục sẽ hiển thị ở đây. Bạn có thể thêm danh mục bằng cách nhấp vào nút 'Tạo danh mục'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} bài viết | {count} bài viết",
        "EXPAND": "Hiện danh mục con",
        "COLLAPSE": "Ẩn danh mục con",
        "MENU": {
          "NEW_ARTICLE": "Bài viết mới",
          "ADD_SUBCATEGORY": "Thêm danh mục con",
          "EDIT": "Sửa",
          "DELETE": "Xoá"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Danh mục đã được tạo thành công",
            "ERROR_MESSAGE": "Không thể tạo danh mục"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Danh mục cập nhật thành công",
            "ERROR_MESSAGE": "Không thể cập nhật danh mục"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Xoá danh mục thành công",
            "ERROR_MESSAGE": "Không thể xoá danh mục"
          },
          "CONFIRM": {
            "TITLE": "Xoá danh mục",
            "DESCRIPTION": "Bạn có chắc chắn muốn xoá danh mục này? Các bài viết của nó sẽ trở thành chưa phân loại.",
            "DESCRIPTION_WITH_CHILDREN": "Bạn có chắc chắn muốn xoá danh mục này? Các bài viết của nó sẽ trở thành chưa phân loại và {count} danh mục con của nó sẽ được chuyển lên cấp cao nhất. | Bạn có chắc chắn muốn xoá danh mục này? Các bài viết của nó sẽ trở thành chưa phân loại và {count} danh mục con của nó sẽ được chuyển lên cấp cao nhất.",
            "CONFIRM": "Xoá"
          }
        },
        "HEADER": {
          "CREATE": "Tạo danh mục",
          "EDIT": "Sửa danh mục",
          "DESCRIPTION": "Chỉnh sửa danh mục sẽ cập nhật danh mục trong cổng thông tin công khai.",
          "PORTAL": "Cổng",
          "LOCALE": "Ngôn ngữ"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Tên",
            "PLACEHOLDER": "Tên danh mục",
            "ERROR": "Tên bắt buộc có"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Danh mục slug cho url",
            "ERROR": "Phải có Slug",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Mô tả",
            "PLACEHOLDER": "Đưa ra một mô tả ngắn về danh mục.",
            "ERROR": "Mô tả bắt buộc có"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Danh mục cha",
            "PLACEHOLDER": "Chọn danh mục cha",
            "NONE": "Không có (cấp cao nhất)"
          }
        },
        "BUTTONS": {
          "CREATE": "Tạo",
          "EDIT": "Cập nhật",
          "CANCEL": "Huỷ"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Không có ngôn ngữ nào | {n} ngôn ngữ | {n} ngôn ngữ",
      "NEW_LOCALE_BUTTON_TEXT": "Ngôn ngữ mới",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} bài viết | {count} bài viết",
        "CATEGORIES_COUNT": "{count} danh mục | {count} danh mục",
        "DEFAULT": "Mặc định",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Đặt làm mặc định",
          "DELETE": "Xoá"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Thêm ngôn ngữ",
        "DESCRIPTION": "Chọn ngôn ngữ mà bài viết này sẽ được viết. Ngôn ngữ này sẽ được thêm vào danh sách bản dịch của bạn, và bạn có thể thêm sau.",
        "COMBOBOX": {
          "PLACEHOLDER": "Chọn ngôn ngữ..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Ngôn ngữ được thêm thành công",
          "ERROR_MESSAGE": "Không thể thêm ngôn ngữ. Vui lòng thử lại."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Đang lưu...",
          "SAVED": "Đã lưu"
        },
        "PREVIEW": "Xem trước",
        "PUBLISH": "Phát hành",
        "DRAFT": "Draft",
        "ARCHIVE": "Lưu trữ",
        "BACK_TO_ARTICLES": "Quay lại danh sách bài viết"
      },
      "DRAFT": {
        "PENDING_LABEL": "Thay đổi chưa xuất bản",
        "PROMOTE": "Xuất bản thay đổi",
        "DISCARD": "Hủy thay đổi",
        "PROMOTE_SUCCESS": "Các thay đổi Draft đã được xuất bản vào bài viết trực tiếp",
        "PROMOTE_ERROR": "Không thể xuất bản các thay đổi Draft",
        "DISCARD_SUCCESS": "Các thay đổi Draft đã bị huỷ",
        "DISCARD_ERROR": "Không thể huỷ các thay đổi Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Lịch sử phiên bản",
        "TITLE": "Lịch sử phiên bản",
        "BACK": "Quay lại bài viết",
        "LOADING": "Đang tải các phiên bản...",
        "EMPTY": "Chưa có phiên bản nào. Các chỉnh sửa cho bài viết này sẽ hiển thị ở đây.",
        "EMPTY_CONTENT": "Phiên bản này không có nội dung.",
        "CURRENT_BADGE": "Hiện tại",
        "RESTORED_BADGE": "Đã khôi phục",
        "AUTOMATED_USER": "Cập nhật tự động",
        "RESTORE": "Khôi phục phiên bản này",
        "RESTORE_DIALOG": {
          "TITLE": "Khôi phục phiên bản này?",
          "DESCRIPTION": "Bài viết sẽ quay lại nội dung của phiên bản này. Không có gì bị mất — văn bản hiện tại vẫn được lưu trong lịch sử, và nếu bài viết đã được phát hành, trang công khai sẽ vẫn hiển thị phiên bản trực tiếp cho đến khi bạn phát hành thay đổi này.",
          "CONFIRM": "Khôi phục"
        },
        "RESTORE_SUCCESS": "Đã khôi phục phiên bản",
        "RESTORE_ERROR": "Không thể khôi phục phiên bản này",
        "FETCH_ERROR": "Không thể tải lịch sử phiên bản"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Thêm thuộc tính",
        "TRANSLATE": "Dịch",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Chưa được phân loại",
        "EDITOR_PLACEHOLDER": "Viết gì đó...",
        "HTML_EMBED": {
          "TITLE": "Chèn HTML tùy chỉnh",
          "DESCRIPTION": "Dán mã HTML thô như iframe, embed hoặc đoạn widget. Nó sẽ được hiển thị nguyên trạng trong bài viết đã xuất bản.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Chèn"
        },
        "PRIMARY_CATEGORY": "Danh mục chính"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Thuộc tính bài viết",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Mô tả meta",
        "META_DESCRIPTION_PLACEHOLDER": "Thêm mô tả meta",
        "META_TITLE": "Tiêu đề meta",
        "META_TITLE_PLACEHOLDER": "Thêm tiêu đề meta",
        "META_TAGS": "Các thẻ meta",
        "META_TAGS_PLACEHOLDER": "Thêm thẻ meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Phiên bản ngôn ngữ",
        "LANGUAGE_MUTATIONS_EMPTY": "Chưa có bài viết liên kết",
        "ADD_MUTATION": "Thêm",
        "REMOVE_MUTATION": "Gỡ"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Liên kết phiên bản ngôn ngữ",
        "SEARCH_PLACEHOLDER": "Tìm bài viết theo tiêu đề",
        "EMPTY": "Không tìm thấy bài viết phù hợp",
        "CANCEL": "Hủy",
        "ADD_SELECTED": "Thêm mục đã chọn",
        "SUCCESS": "Đã cập nhật phiên bản",
        "ERROR": "Không thể cập nhật phiên bản"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Dịch bài viết",
        "DESCRIPTION": "Chọn các ngôn ngữ bạn muốn dịch bài viết này sang. Những ngôn ngữ đã được dịch sẽ được dịch lại thành Draft để xem xét.",
        "EMPTY": "Không có ngôn ngữ nào khác.",
        "CONNECTED_BADGE": "Đã dịch",
        "CANCEL": "Hủy",
        "TRANSLATE": "Dịch",
        "SUCCESS": "Quá trình dịch sẽ sớm bắt đầu. Các bài viết đã dịch sẽ sớm xuất hiện dưới dạng phiên bản ngôn ngữ.",
        "ERROR": "Không thể bắt đầu dịch"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Lỗi khi lưu bài viết"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Cổng mới",
      "PORTALS": "Cổng",
      "CREATE_PORTAL": "Tạo và quản lý nhiều cổng thông tin",
      "ARTICLES": "bài viết",
      "DOMAIN": "miền",
      "PORTAL_NAME": "Tên cổng"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Tạo cổng mới",
      "DESCRIPTION": "Đặt tên cho cổng thông tin của bạn và tạo một slug URL thân thiện với người dùng. Bạn có thể chỉnh sửa cả hai sau này trong phần cài đặt.",
      "CONFIRM_BUTTON_LABEL": "Tạo",
      "NAME": {
        "LABEL": "Tên",
        "PLACEHOLDER": "Hướng dẫn sử dụng",
        "MESSAGE": "Chọn một tên cho cổng thông tin của bạn.",
        "ERROR": "Tên bắt buộc có"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Phải có Slug",
        "FORMAT_ERROR": "Chỉ sử dụng chữ cái, chữ số và dấu gạch ngang, ví dụ: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Không thể tải ảnh lên! Vui lòng thử lại",
          "IMAGE_UPLOAD_SUCCESS": "Đã thêm ảnh thành công. Vui lòng nhấp vào lưu thay đổi để lưu logo",
          "IMAGE_DELETE_SUCCESS": "Đã xóa logo thành công",
          "IMAGE_DELETE_ERROR": "Không thể xóa logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Kích thước ảnh phải nhỏ hơn {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Tên",
          "PLACEHOLDER": "Tên cổng",
          "ERROR": "Tên bắt buộc có"
        },
        "HEADER_TEXT": {
          "LABEL": "Văn bản tiêu đề",
          "PLACEHOLDER": "Văn bản tiêu đề cổng thông tin"
        },
        "PAGE_TITLE": {
          "LABEL": "Tiêu đề trang",
          "PLACEHOLDER": "Tiêu đề trang cổng thông tin"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Liên kết trang chủ",
          "PLACEHOLDER": "Liên kết trang chủ cổng thông tin",
          "ERROR": "URL không hợp lệ. Liên kết trang chủ phải bắt đầu bằng 'http://' hoặc 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget chat trực tiếp",
          "PLACEHOLDER": "Chọn widget chat trực tiếp",
          "HELP_TEXT": "Chọn widget chat trực tiếp sẽ hiển thị trên trung tâm trợ giúp của bạn"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Công khai truy cập",
          "HELP_TEXT": "Cho phép mọi người có liên kết truy cập cổng thông tin.",
          "OPTIONS": {
            "PUBLIC": "Có",
            "PRIVATE": "Không"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Đích liên kết",
          "HELP_TEXT": "Chọn xem các liên kết trong bài viết mở trong cửa sổ hiện tại hay cửa sổ mới.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Cửa sổ hiện tại",
            "NEW_WINDOW": "Cửa sổ mới"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Kích thước ảnh mặc định",
          "HELP_TEXT": "Kích thước được áp dụng cho mọi hình ảnh bạn chèn vào bài viết. Chọn Original để chèn ảnh theo kích thước gốc của chúng và chọn kích thước riêng cho từng ảnh thay vào đó."
        },
        "BRAND_COLOR": {
          "LABEL": "Màu thương hiệu"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML tùy chỉnh",
          "PLACEHOLDER": "<!-- Dán đoạn mã phân tích hoặc theo dõi của bạn vào đây -->",
          "HELP_TEXT": "Được chèn vào đầu thẻ <body> trên mọi trang trung tâm trợ giúp. Sử dụng nó cho Google Analytics, Google Tag Manager hoặc bất kỳ đoạn mã theo dõi nào khác. Mã được hiển thị chính xác như khi nhập vào và không được xác thực."
        },
        "SAVE_CHANGES": "Lưu thay đổi"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Tên miền tuỳ chỉnh",
          "LABEL": "Tên miền tuỳ chỉnh:",
          "DESCRIPTION": "Bạn có thể lưu trữ cổng thông tin của mình trên một tên miền tuỳ chỉnh. Ví dụ: nếu trang web của bạn là yourdomain.com và bạn muốn cổng thông tin của mình khả dụng tại docs.yourdomain.com, chỉ cần nhập vào trường này.",
          "PLACEHOLDER": "Tên miền tuỳ biến cổng",
          "EDIT_BUTTON": "Sửa tên miền tuỳ chỉnh",
          "ADD_BUTTON": "Thêm tên miền tuỳ chỉnh",
          "DIALOG": {
            "ADD_HEADER": "Thêm tên miền tuỳ chỉnh",
            "EDIT_HEADER": "Sửa tên miền tuỳ chỉnh",
            "ADD_CONFIRM_BUTTON_LABEL": "Thêm tên miền",
            "EDIT_CONFIRM_BUTTON_LABEL": "Cập nhật tên miền",
            "LABEL": "Tên miền tuỳ chỉnh",
            "PLACEHOLDER": "Tên miền tuỳ biến cổng",
            "ERROR": "Yêu cầu nhập tên miền tuỳ chỉnh"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Cấu hình DNS",
            "DESCRIPTION": "Đăng nhập vào tài khoản bạn có với nhà cung cấp DNS, và thêm bản ghi CNAME bên dưới cho tên miền phụ của bạn.",
            "HELP_TEXT": "Sau khi hoàn tất, bạn có thể liên hệ với bộ phận hỗ trợ của chúng tôi để yêu cầu chứng chỉ SSL được tạo tự động.",
            "CONFIRM_BUTTON_LABEL": "Đã hiểu!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Xoá {portalName}",
          "HEADER": "Xóa cổng thông tin",
          "DESCRIPTION": "Xoá vĩnh viễn cổng thông tin này. Hành động này không thể hoàn tác",
          "DIALOG": {
            "HEADER": "Bạn có chắc chắn muốn xoá {portalName}?",
            "DESCRIPTION": "Đây là hành động vĩnh viễn và không thể hoàn tác.",
            "CONFIRM_BUTTON_LABEL": "Xoá"
          }
        },
        "EDIT_CONFIGURATION": "Sửa cấu hình"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Cổng thông tin được tạo thành công",
          "ERROR_MESSAGE": "Không thể tạo cổng thông tin"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Cổng thông tin được cập nhật thành công",
          "ERROR_MESSAGE": "Không thể cập nhật cổng thông tin"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Tệp đính kèm",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Thêm tệp",
      "DROP_HERE": "Kéo và thả tệp vào đây",
      "COPY_LINK": "Sao chép liên kết",
      "LINK_COPIED": "Đã sao chép liên kết vào bộ nhớ tạm",
      "COPY_FAILED": "Sao chép liên kết thất bại",
      "DELETE": "Xoá",
      "CANCEL": "Huỷ",
      "QUEUED": "Đang chờ",
      "UPLOADING": "Đang tải lên",
      "UPLOAD_FAILED": "Tải tệp lên thất bại",
      "FILE_TOO_LARGE": "Tệp vượt quá giới hạn kích thước 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Từ điển dịch thuật",
        "DESCRIPTION": "Các thuật ngữ được định nghĩa ở đây sẽ được thêm vào prompt dịch AI để chúng luôn được dịch theo cùng một cách. Thuật ngữ chính được viết bằng {locale}."
      },
      "NEW_TERM": "Thuật ngữ mới",
      "EMPTY_STATE": {
        "TITLE": "Chưa có thuật ngữ nào trong từ điển",
        "SUBTITLE": "Thêm một thuật ngữ và bản dịch của nó cho từng ngôn ngữ. Khi một bài viết được dịch, các thuật ngữ này sẽ được áp dụng để đảm bảo cách dùng từ của sản phẩm luôn nhất quán."
      },
      "LIST": {
        "TERM": "Thuật ngữ",
        "TRANSLATIONS": "Bản dịch",
        "ACTIONS": "Hành động"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Thêm thuật ngữ",
          "EDIT": "Sửa thuật ngữ",
          "DESCRIPTION": "Thuật ngữ bên dưới sẽ được áp dụng trong quá trình dịch AI cho các bài viết trung tâm trợ giúp của bạn.",
          "PORTAL": "Cổng",
          "PRIMARY_LANGUAGE": "Ngôn ngữ chính"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Thuật ngữ ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Thuật ngữ là bắt buộc"
          },
          "DESCRIPTION": {
            "LABEL": "Ngữ cảnh / ghi chú (không bắt buộc)",
            "PLACEHOLDER": "Thời điểm và cách sử dụng thuật ngữ này, giúp người dịch phân biệt rõ nghĩa."
          },
          "TRANSLATIONS": "Bản dịch",
          "TRANSLATION_PLACEHOLDER": "Để trống để AI tự do dịch",
          "AUTO_TRANSLATE": {
            "BUTTON": "Tự động dịch tất cả",
            "CONFIRM": "Dịch sang {count} ngôn ngữ bằng AI?",
            "CONFIRM_BUTTON": "Dịch",
            "CANCEL": "Huỷ",
            "SUCCESS": "Đã tạo bản dịch — hãy xem lại và lưu",
            "ERROR": "Không thể tự động dịch, vui lòng thử lại"
          }
        },
        "BUTTONS": {
          "CREATE": "Thêm thuật ngữ",
          "EDIT": "Lưu",
          "CANCEL": "Huỷ"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Đã thêm thuật ngữ thành công",
            "ERROR_MESSAGE": "Không thể thêm thuật ngữ, vui lòng thử lại"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Đã cập nhật thuật ngữ thành công",
            "ERROR_MESSAGE": "Không thể cập nhật thuật ngữ, vui lòng thử lại"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Xoá thuật ngữ",
          "DESCRIPTION": "Bạn có chắc chắn muốn xoá thuật ngữ này? Nó sẽ không còn được áp dụng trong quá trình dịch nữa.",
          "CONFIRM": "Xoá"
        },
        "API": {
          "SUCCESS_MESSAGE": "Đã xoá thuật ngữ thành công",
          "ERROR_MESSAGE": "Không thể xoá thuật ngữ, vui lòng thử lại"
        }
      }
    }
  }
}
